module.exports = __webpack_public_path__ + "fonts/CalibreBold.b99fc08d.woff";